const topProductsDataFormatter = (data) => ({
    chartData: ((data || {}).leadProducts || []).map(({ productName, leadCount, }) => ({
        description: `${productName}`,
        value: leadCount,
    })),
    lastUpdatedUTC: (data || {}).lastUpdatedUTC || '',
});
export default topProductsDataFormatter;
